import { render, staticRenderFns } from "./image.vue?vue&type=template&id=4baf5c21&scoped=true&"
import script from "./image.vue?vue&type=script&lang=js&"
export * from "./image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baf5c21",
  null
  
)

export default component.exports